import { Disabled } from "@wordpress/components";
import { Component } from "@wordpress/element";
import PropTypes from "prop-types";
import Block from "./Block";

class Editor extends Component {
	static propTypes = {
		/**
		 * The attributes for this block.
		 */
		attributes: PropTypes.object.isRequired,
		/**
		 * A callback to update attributes.
		 */
		setAttributes: PropTypes.func.isRequired,
	};

	renderViewMode() {
		const { attributes } = this.props;
		return (
			<Disabled>
				<Block attributes={attributes} />
			</Disabled>
		);
	}

	render() {
		return <div>{this.renderViewMode()}</div>;
	}
}

export default Editor;
